import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "cover" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "details" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "date mt-2" }
const _hoisted_7 = { class: "flex gap-2 items-center" }
const _hoisted_8 = { class: "service" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = ["src", "alt"]


import { trackClick } from '@/utils/analytics'


export default /*@__PURE__*/_defineComponent({
  __name: 'ObjavaCard',
  props: {
    service: {},
    title: {},
    description: {},
    href: {},
    background: {},
    backgroundPosition: {},
    logo: {},
    date: {},
    trackId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: __props.href,
    target: "_blank",
    rel: "noopener noreferrer",
    class: "card",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackClick)(`press:${__props.trackId}`)))
  }, [
    _createElementVNode("div", {
      class: "background",
      style: _normalizeStyle({
                backgroundImage: __props.background,
                backgroundPosition: __props.backgroundPosition ?? 'center center',
            })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "play-icon",
        src: require('@/assets/png-icons/play.png'),
        alt: "play icon"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.title), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.date), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "delimiter" }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.service), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(__props.description), 1)
          ]),
          _createElementVNode("img", {
            class: "logo",
            src: __props.logo,
            alt: `${__props.service} logo`
          }, null, 8, _hoisted_10)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})